import AssetHandler from "./AssetHandlerRoot.vue"

export default AssetHandler
